import { css } from "../helpers/webComponents";

const mapStyles: string = css`
    .map-parent {
        width: 100%;
        height: 100%;
        background-color: #00000097;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .map-container {
        z-index: 99;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .map-image {
        width: 700px;
        border-radius: 20px;
        height: auto;
    }

    .map-container h3 {
        position: absolute;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);

    }
    .close-button {
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 5px 10px;
        border: none;
        cursor: pointer;
        background: transparent;
        color: white;
        transition: 200ms;
    }

    .close-button:hover {
        color: red;
        transition: 200ms;
    }
`;

export class MapComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>
                ${mapStyles}
            </style>
            <div class="map-parent">
                <div class="map-container">
                    <img class="map-image" src="/assets/img/items/map.png" alt="Map" />
                    <h3>Map</h3>
                    <button class="close-button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x">
                            <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                        </svg>
                    </button>
                </div>
            </div>
        `;

        this.shadowRoot.querySelector(".close-button")?.addEventListener("click", () => {
            this.remove();
        });
    }
}
